import React from 'react';
import { URL } from '../variables';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { login } from '../actions/AppActions';
import moment from 'moment';
import { getLanguageTexts, getSelectedLanguage, languageOptions, setSelectedLanguage } from '../language';
import { CandidateLoader } from '../Home/CandidateUi';
import { CircleNotch } from '@phosphor-icons/react';
// import './alert.css';

class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            faculdade: null,
            loading: false,
            msgErro: '',
            credencial: '',
            password: '',
            redirect: false,
            loading_login:false,
            path: '',
            selectedLanguage: getSelectedLanguage()
        }
        this.handleLanguageChange = this.handleLanguageChange.bind(this);
        this.handleLanguageEvent = this.handleLanguageEvent.bind(this);

    }

    handleLanguageChange(event) {
        this.setState({ selectedLanguage: setSelectedLanguage(event.target.value) });
    }

    handleLanguageEvent(event) {
        this.setState({ selectedLanguage: event.detail || getSelectedLanguage() });
    }

    login(event) {
        event.preventDefault();
        let faculdade_id = null;
        if (this.state.faculdade != null) {
            faculdade_id = this.state.faculdade.id;
        }
        this.setState({loading_login:true,msgErro:''});
        fetch(`${URL}api/auth/external/login`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                // 'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                credencial: this.state.credencial,
                password: this.state.password,
                faculdade_id
            })
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp)
                if(resp.message == 'Server Error'){
                    this.timeout = setTimeout(()=>{
                        this.login(event)
                    },5000);
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);

                    this.setState({ loading: false, msgErro: erro, refresh: false, loadingMore: false,loading_login:false });
                }
                else {
                    localStorage.setItem('token', resp.access_token);
                    this.props.login({ token: resp.access_token, user: {} });
                    // this.setState({ redirect: true, path: '/home', loading: false });
                    // if (resp.faculdade != null) {
                    //     this.setState({ faculdade: resp.faculdade, loading: false, msgErro: '' });
                    // }
                    // else {
                    //     this.setState({ redirect: true, path: '/', loading: false });
                    // }
                    // this.setState({ loading: false, refresh: false, loadingMore: false, msgErro: '' });

                }




            } catch (err) {
                console.log(err);
                this.setState({ loading: false, msgErro: getLanguageTexts(this.state.selectedLanguage).server_response_error, refresh: false, loadingMore: false,loading_login:false });

            }

        })
            .catch((err) => {
                console.log(err);
                this.setState({ loading: false, msgErro: getLanguageTexts(this.state.selectedLanguage).internet_connection_error, refresh: false, loadingMore: false,loading_login:false });
            });
    }

    get_faculdade(slug) {
        fetch(`${URL}api/get_faculdade/${slug}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                // 'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);

                    this.setState({ loading: false, msgErro: erro, });
                }
                else {
                    if (resp.faculdade != null) {
                        this.setState({ faculdade: resp.faculdade, loading: false, msgErro: '' });
                    }
                    else {
                        this.setState({ redirect: true, path: '/', loading: false });
                    }
                    // this.setState({ loading: false, refresh: false, loadingMore: false, msgErro: '' });

                }




            } catch (err) {
                console.log(err);
                this.setState({ loading: false, msgErro: getLanguageTexts(this.state.selectedLanguage).server_response_error, });

            }

        })
            .catch((err) => {
                console.log(err);
                this.setState({ loading: false, msgErro: getLanguageTexts(this.state.selectedLanguage).internet_connection_error, });
            });
    }

    componentDidMount() {
        const { match: { params } } = this.props;
        localStorage.setItem('external_camera_theme', 'light');
        document.body.classList.remove('external-camera-dark-theme');
        window.addEventListener('external_camera_language_change', this.handleLanguageEvent);
        this.setState({ loading: true, msgErro: '' });
        this.get_faculdade(params.slug);
    }


    changeCPF(event) {
        let text = event.target.value
        let final_num = '';

        if (text.length > 0) {
            text = text.replace('.', '').replace('-', '').replace('.', '');
            if (text.length <= 11) {


                for (let i = 0; i < text.length; i++) {
                    if (!isNaN(text[i])) {
                        if (i == 3) {
                            final_num += '.' + text[i];
                        }
                        else if (i == 6) {
                            final_num += '.' + text[i];
                        }
                        else if (i == 9) {
                            final_num += '-' + text[i];
                        }
                        else {
                            final_num += text[i] + '';
                        }
                    }
                }
                // this.setState({ cpf: final_num });
                this.setState({ credencial: final_num })
            }

        }
        else {
            this.setState({ credencial: final_num })
        }


    }

    changeEmail(event) {
        let text = event.target.value
        let final_num = '';
        final_num = text;
        this.setState({ credencial: final_num })
    }

    changeCPFEmail(event) {
        let text = event.target.value
        let final_num = '';
        if (text.length > 0 && isNaN(text[0])) {
            final_num = text;
            this.setState({ credencial: final_num })
        }
        else if (text.length > 0) {
            text = text.replace('.', '').replace('-', '').replace('.', '');
            if (text.length <= 11) {


                for (let i = 0; i < text.length; i++) {
                    // if (Number.isInteger(text[i])) {
                    if (i == 3) {
                        final_num += '.' + text[i];
                    }
                    else if (i == 6) {
                        final_num += '.' + text[i];
                    }
                    else if (i == 9) {
                        final_num += '-' + text[i];
                    }
                    else {
                        final_num += text[i] + '';
                    }
                    // }
                }
                // this.setState({ cpf: final_num });
                this.setState({ credencial: final_num })
            }

        }
        else {
            this.setState({ credencial: final_num })
        }


    }

    changePassword(event) {
        this.setState({ password: event.target.value })
    }

    componentWillUnmount(){
        window.removeEventListener('external_camera_language_change', this.handleLanguageEvent);
        clearTimeout(this.timeout);
    }

    render() {
        const t = getLanguageTexts(this.state.selectedLanguage);
        return (
            <div className="candidate-login-page">
                {this.state.redirect == true && <Redirect to={this.state.path} />}
                {this.state.loading && <div className="candidate-auth-loading">
                    <CandidateLoader title={t.loading_data} description={t.external_camera_loading_hint} />
                </div>}
                {!this.state.loading && this.state.faculdade != null && <div className="candidate-login-layout">
                    <section className="candidate-login-panel">
                        <div className="candidate-login-form-wrap">
                            <div className="candidate-login-logo">
                                <img src={this.state.faculdade.logo || require('../assets/images/logo-ontest.png')} alt="logo" />
                            </div>

                            <div className="candidate-login-form">
                                <span className="candidate-auth-kicker">{t.external_camera_access}</span>
                                <h1>{t.welcome}</h1>
                                <p>{t.login_subtitle}</p>

                                <form className="form-horizontal" onSubmit={this.login.bind(this)}>
                                    {this.state.faculdade.type_login == 'all' && <div className="form-group candidate-auth-field">
                                        <label>{t.cpf_or_email} <span>*</span></label>
                                        <input id="credencial" type="username" className="form-control" name="credencial"
                                            value={this.state.credencial} onChange={this.changeCPFEmail.bind(this)} required autoComplete="email" autoFocus />
                                    </div>}

                                    {this.state.faculdade.type_login == 'cpf' && <div className="form-group candidate-auth-field">
                                        <label>{t.cpf} <span>*</span></label>
                                        <input id="credencial" type="username" className="form-control" name="credencial"
                                            value={this.state.credencial} onChange={this.changeCPF.bind(this)} required autoFocus />
                                    </div>}

                                    {this.state.faculdade.type_login == 'email' && <div className="form-group candidate-auth-field">
                                        <label>{t.email} <span>*</span></label>
                                        <input id="credencial" type="username" className="form-control" name="credencial"
                                            value={this.state.credencial} onChange={this.changeEmail.bind(this)} required autoComplete="email" autoFocus />
                                    </div>}

                                    <div className="form-group candidate-auth-field">
                                        <label>{t.password} <span>*</span></label>
                                        <input id="password" type="password"
                                            value={this.state.password}
                                            onChange={this.changePassword.bind(this)}
                                            className="form-control" name="password"
                                            required autoComplete="current-password" />

                                        {this.state.faculdade.texto_login != null && <span className="candidate-login-help" role="alert">
                                            {this.state.faculdade.texto_login}
                                        </span>}
                                    </div>

                                    {this.state.faculdade.reset_password == true && <div className="form-group candidate-auth-field">
                                        <a target="_blank" rel="noreferrer" href={this.state.faculdade.reset_password_link} className="candidate-login-help">
                                            {this.state.faculdade.reset_password_text}
                                        </a>
                                    </div>}

                                    <div className="form-group candidate-login-action">
                                        {this.state.msgErro != '' && <div className="candidate-error-badge" role="alert">{this.state.msgErro}</div>}
                                        {this.state.loading_login == false && <button className="btn btn-primary waves-effect waves-light" type="submit">
                                            <i className="mdi mdi-login" aria-hidden="true"></i> {t.enter}
                                        </button>}
                                        {this.state.loading_login == true && <button className="btn btn-primary waves-effect waves-light" type="button" disabled>
                                            <CircleNotch className="candidate-button-loader" weight="bold" aria-hidden="true" />
                                            {t.entering}
                                        </button>}
                                    </div>
                                </form>
                            </div>
                            <div className="candidate-login-footer">
                                <p>© {moment().format('YYYY')} OnTest</p>
                                <label className="candidate-login-language external-camera-login-language">
                                    <i className="mdi mdi-web"></i>
                                    <select value={this.state.selectedLanguage} onChange={this.handleLanguageChange} aria-label={t.language_label}>
                                        {languageOptions.map((item) => (
                                            <option key={item.value} value={item.value}>{item.value}</option>
                                        ))}
                                    </select>
                                </label>
                            </div>
                        </div>
                    </section>
                    <aside className="candidate-login-visual" style={{ backgroundImage: `url(${require("../assets/images/bg_vestibular.jpeg")})` }}>
                        <div className="candidate-login-visual-overlay"></div>
                        <div className="candidate-login-visual-copy">
                            <span>{t.external_camera_hero_label}</span>
                            <h2>{t.external_camera_hero_title}</h2>
                            <p>{t.external_camera_hero_hint}</p>
                        </div>
                    </aside>
                </div>}
            </div>
        );
    }


}

const mapsStateToProps = (state) => (
    {
    }
);

export default connect(mapsStateToProps, { login })(Login);
